import { useEffect, useRef, useState } from "react";
import useWindowSize from "../../../../common/hooks/useWindowSize";
import { Requirements } from "../../../../services/GroupGrowth/groupGrowth.types";
import { SsiEligibilityWindowExtended } from "../../../../services/SSIUpline/ssiUplineAPI.types";
import breakpoints from "../../../../common/scss/breakpoints.module.scss";
import OutOfProgramTable from "../OutOfProgramTable/OutOfProgramTable";
import { OutOfProgramCard } from "../OutOfProgramCard/OutOfProgramCard";
import "./OutOfProgramWrapper.scss";

export type Row = {
  AboName: string;
  AboNum: string;
  Aff: string;
  Requirements: Requirements;
  EligibilityWindow: SsiEligibilityWindowExtended;
  SponsorName: string;
  SponsorNum: string;
  IsHighlighted?: boolean;
  scrollRef?: boolean;
};

type Props = {
  rows: Row[];
  isLoading: boolean;
  selectedAboNumber: string;
};

export const OutOfProgramWrapper = ({ rows, isLoading, selectedAboNumber }: Props) => {
  const [deviceSize, setDeviceSize] = useState("desktop" as "desktop" | "mobile");
  const { width } = useWindowSize();

  useEffect(() => {
    if (width) {
      const newDeviceSize = Number(width) > Number(breakpoints.mobileLarge) ? "desktop" : "mobile";

      if (deviceSize !== newDeviceSize) {
        setDeviceSize(newDeviceSize);
      }
    }
  }, [deviceSize, width]);

  if (!isLoading && rows.length === 0) {
    return <></>;
  }

  const OutOfProgramCardListRenderer = () => {
    const scrollRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, [scrollRef]);

    return (
      <div className="OutOfProgramWrapper">
        {isLoading && (
          <OutOfProgramCard key={`isLoading_ssi_upline_inWindow_card`} row={{} as Row} isLoading={isLoading} />
        )}
        {rows ? (
          rows.map((row, ind) => (
            <div key={`${row.AboNum}-${ind}`} ref={row.scrollRef ? scrollRef : null}>
              <OutOfProgramCard row={row} isLoading={isLoading} />
            </div>
          ))
        ) : (
          <></>
        )}
      </div>
    );
  };

  return deviceSize === "mobile" ? (
    <OutOfProgramCardListRenderer />
  ) : (
    <OutOfProgramTable rows={rows} isLoading={isLoading} selectedAboNumber={selectedAboNumber} />
  );
};
